import { svg } from "lit";
const icon = svg `<path d="M13.15 40.9226L16.0153 28.5843L6.44238 20.2882L19.073 19.1921L23.9999 7.55762L28.9267 19.1921L41.5574 20.2882L31.9844 28.5843L34.8498 40.9226L23.9999 34.3766L13.15 40.9226Z" fill="currentColor"/>`;
export default icon;
